// extracted by mini-css-extract-plugin
export default {"user-card":"UserCard_user-card__Mqmpq","circle-mask":"UserCard_circle-mask__Y+sjt","user-name":"UserCard_user-name__DELgM"};